import React, { useState } from 'react';
import {
  Project,
  ProjectStatus,
  ProjectStatusCount,
  ProjectStatusValues,
} from 'state/types';

export const tabColors = {
  ALL: 'border-blue-600 text-blue-600 hover:text-blue-600',
  ACTIVE: 'border-emerald-800 text-emerald-800 hover:text-emerald-800',
  'PENDING PROPOSAL': 'border-red-700 text-red-700 hover:text-red-700',
  'PROPOSAL SENT': 'border-yellow-200 text-yellow-500 hover:text-yellow-500',
  COMPLETE: 'border-gray-200 text-black-500 hover:text-black-500',
  LOST: 'border-amber-400 text-amber-800 hover:text-black-100',
};

export const chipColors = {
  ALL: 'text-blue-600 bg-blue-200',
  ACTIVE: 'text-emerald-800 bg-emerald-200',
  'PENDING PROPOSAL': 'text-red-700 bg-red-100',
  'PROPOSAL SENT': 'text-yellow-500 bg-yellow-200',
  COMPLETE: 'text-black-500 bg-gray-200',
  LOST: 'text-amber-800 bg-amber-400',
};

type Props = {
  statuses: Project['status'][];
  status: ProjectStatusValues;
  projects: ProjectStatus;
  isEditingProjectRow: boolean;
  handleStatusClick: (status: Project['status']) => void;
  statusCount: ProjectStatusCount;
};

export const StatusBar = ({
  statuses,
  status,
  isEditingProjectRow,
  handleStatusClick,
  statusCount,
}: Props) => {
  const [selectedProjectStatus, setSelectedProjectStatus] = useState(status);

  const warnDisabledClick = () => {
    alert("You can't perform this action while editing a project row");
  };

  return (
    <ul role="tablist" className="w-full flex items-center gap-x-6">
      {statuses.map((status, idx) => {
        return (
          <li
            key={status}
            className={`flex py-2 border-b-2 ${selectedProjectStatus === status ? tabColors[status] : 'border-white text-gray-500'}`}
          >
            <button
              role="tab"
              aria-selected={selectedProjectStatus === status ? true : false}
              aria-controls={`tabpanel-${idx + 1}`}
              className={`${isEditingProjectRow ? 'cursor-not-allowed' : ''} px-2 rounded-lg duration-150 ${selectedProjectStatus === status ? tabColors[status] : null}`}
              onClick={
                isEditingProjectRow
                  ? warnDisabledClick
                  : () => {
                      setSelectedProjectStatus(status);
                      handleStatusClick(status);
                    }
              }
            >
              <span className="text-sm">{status.toUpperCase()}</span>
            </button>
            <div className="font-medium whitespace-nowrap">
              {/* TODO: DARKMODE: dark:bg-gray-800 */}
              <div
                className={`inline px-3 py-1 text-[10px] font-normal rounded-full gap-x-2 ${chipColors[status]}`}
              >
                {statusCount[status]}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};
